export default __webpack_public_path__ + "static/media/01AW1JAN66.3c43a243.jpg";